import { render, staticRenderFns } from "./SpamEmail.vue?vue&type=template&id=270f55f7&scoped=true"
import script from "./SpamEmail.vue?vue&type=script&lang=js"
export * from "./SpamEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270f55f7",
  null
  
)

export default component.exports